import { render, staticRenderFns } from "./lawsuit_2.vue?vue&type=template&id=326bdb69&scoped=true"
import script from "./lawsuit_2.vue?vue&type=script&lang=js"
export * from "./lawsuit_2.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_2.vue?vue&type=style&index=0&id=326bdb69&prod&scoped=true&lang=less"
import style1 from "./lawsuit_2.vue?vue&type=style&index=1&id=326bdb69&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326bdb69",
  null
  
)

export default component.exports